import { render, staticRenderFns } from "./ResultsSuccess.vue?vue&type=template&id=49a5e71a&"
import script from "./ResultsSuccess.vue?vue&type=script&lang=js&"
export * from "./ResultsSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports